/* eslint-disable react/no-array-index-key */
import BannerWithSearchBar from '../../Components/banners/bannerWithSearchBar/BannerWithSearchBar';
import Layouts from '../../layouts/Layouts';
import BrowseDoctorByConditions from './browseDoctorByConditions/BrowseDoctorByConditions';
import ConsultWithDoctor from './consultWithDoctor/ConsultWithDoctor';
import FeaturedDoctor from './featuredDoctor/FeaturedDoctor';
import MostSearchedSpeciality from './mostSearchedSpeciality/MostSearchedSpeciality';
import { RoundButton } from '../../Components/button';
import { SimpleSlider } from '../../Components/sliders';
import BrowseDoctor from './browseDoctor/BrowseDoctor';
import StickySearchBar from '../../Components/stickySearchBar/StickySearchBar';

const btnTitle = [
  'Karachi',
  'Islamabad',
  'Rawalpindi',
  'Abbottabad',
  'Sialkot',
  'Multan',
  'Lahore',
  'Faisalabad'
];

function FindADoctor() {
  const buttons = btnTitle.map((button, index) => (
    <RoundButton text={button} key={index} />
  ));
  return (
    <Layouts>
      <section className="findADoctor ">
        <BannerWithSearchBar />
        <StickySearchBar />
        <ConsultWithDoctor />
        <FeaturedDoctor />
        <MostSearchedSpeciality />
        <BrowseDoctorByConditions />
        <SimpleSlider sliderTitle="Explore by cities">{buttons}</SimpleSlider>
        <BrowseDoctor />
      </section>
    </Layouts>
  );
}

export default FindADoctor;
